import React from 'react';
import { Link } from 'dva/router';
import moment from 'moment';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, update_time, title}) => (
<div>
    <Link to={`/book/detail/${novel_id}`}>
        <div style={{display:'flex',flexWrap:'wrap',justifyContent:'space-between'}}>
			<div style={{width:'140px',fontSize:'16px',color:'#333',textAlign:'left'}}><LinesEllipsis text={name} maxLine={1}/></div>
            <div style={{margin:'0 20px',width:'200px',fontSize:'16px',color:'#999',textAlign:'left'}}><LinesEllipsis text={title+' '+name} maxLine={1}/></div>
            <div style={{width:'80px',fontSize:'14px',color:'#999'}}>{moment(update_time * 1000).format('MM.DD HH:mm')}</div>            
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_8.js